import React from "react";
import LoginPage from "./login";

export default function IndexPage() {
  return <LoginPage />;
}
